/** @format */
export const CROSSWORD_ARRAY = ['quiz1', 'quiz2', 'mother', 'winter'];
export const CROSSWORD_DISPLAY_MAP = new Map([
	['quiz1', 'Quiz-01'],
	['quiz2', 'Quiz-02'],
	['mother', 'Mother'],
	['winter', 'Winter'],
]);
